import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Question from "../../../../../../assets/img/Help.png";
import Success from "../../../../../../assets/img/Success.png";
import ArrowLeftIcon from "../../../../../../assets/svg/ArrowLeftIcon";
import Modal from "../../../../../../components/Modal/Modal";
import { useUserState } from "../../../../../../context/UserContext";
import { useAuthentication } from "../../../../../hooks/useAuthentication";
import { createNotification } from "../../../../../pojediniProgrami/SectionContainer/API";
import { fetchApplication, fetchUserApplications } from "../../utils";
import Accordion from "../accordion/Accordion";
import { createApplication } from "./api/createApplication";
import { getMyMentor } from "./api/getMyMentor";
import styles from "./EnrollmentForm.module.css";
import EORForm from "./Forms/eORForm";
import ORForm from "./Forms/ORForm";
import TP1Form from "./Forms/TP1Form";
import TP2Form from "./Forms/TP2Form";
import TTForm from "./Forms/TTForm";
import { mentorProgramIdsMapping } from "./utils";

const EnrollmentForm = ({ evidentionUserID }) => {
  const [visibleForm, setVisibleForm] = useState([]);
  const [errorFields, setErrorFieds] = useState([]);
  const [application, setApplication] = useState({});
  const [isFirstModalOpen, setIsFirstModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [myMentors, setMyMentors] = useState([]);
  const [isAccepted, setIsAccepted] = useState({});
  const [applicationsCreated, setApplicationsCreated] = useState({
    OR: false,
    eOR: false,
    TP1: false,
    TP2: false,
    TT: false,
  });
  const [commentModal, setCommentModal] = useState({
    userId: null,
    applicationId: null,
    mentorReview: "",
    isReferadaAccepted: false,
  });
  const [mentorOptions, setMentorOptions] = useState([]);
  const navigate = useNavigate();
  const { role, userData } = useUserState();
  const { authToken } = useAuthentication();
  const userId = role;
  const data = evidentionUserID ? evidentionUserID : userData.id;
  const { programApplicationId } = useParams();

  // OR form
  const formMethodsOne = useForm({
    defaultValues: {
      questionOr1: "",
      questionOr2: "",
      questionOr3: "",
      questionOr4: "",
      questionOr5: "",
      checkOr1: false,
      checkOr2: false,
    },
    mode: "all",
  });
  // eOR form
  const formMethodsTwo = useForm({
    defaultValues: {
      question1: "",
      question2: "",
      question3: "",
      question4: "",
      choice: "",
      question5: "",
      question6: "",
      check1: false,
      check2: false,
    },
    mode: "all",
  });
  // TP1 form
  const formMethodsThree = useForm({
    defaultValues: {
      evidentionOR1Lessons: "",
      evidentionOR1Workshops: "",
      evidentionOR2Lessons: "",
      evidentionOR2Workshops: "",
      evidentionEOR1Lessons: "",
      evidentionEOR1Workshops: "",
      evidentionEOR1LiveModule: "",
      evidentionEOR2Lessons: "",
      evidentionEOR2Workshops: "",
      evidentionEOR2LiveModule: "",
      checkOneTP1: false,
      questionOneTP1: "",
      choiceOneTP1: "",
      choiceTwoTP1: "",
      questionTwoTP1: "",
      questionThreeTP1: "",
      questionFourTP1: "",
      questionFiveTP1: "",
      choiceThreeTP1: "",
      selectOneTP1: "",
      choiceFourTP1: "",
      questionSixTP1: "",
      questionSevenTP1: "",
      questionEightTP1: "",
    },
    mode: "all",
  });
  // TP2 form
  const formMethodsFour = useForm({
    defaultValues: {
      TP2EvidentionOR1Lessons: "",
      TP2EvidentionOR1Workshops: "",
      TP2EvidentionOR2Lessons: "",
      TP2EvidentionOR2Workshops: "",
      TP2EvidentionOR3Lessons: "",
      TP2EvidentionOR3Workshops: "",
      TP2EvidentionEOR1Lessons: "",
      TP2EvidentionEOR1Workshops: "",
      TP2EvidentionEOR1LiveModule: "",
      TP2EvidentionEOR2Lessons: "",
      TP2EvidentionEOR2Workshops: "",
      TP2EvidentionEOR2LiveModule: "",
      TP2EvidentionEOR3Lessons: "",
      TP2EvidentionEOR3Workshops: "",
      TP2EvidentionEOR3LiveModule: "",
      checkOneTP2: false,
      choiceOneTP2: "",
      choiceTwoTP2: "",
      questionTwoTP2: "",
      questionThreeTP2: "",
      evidentionTRIJADA: "",
      evidentionAGS: "",
      evidentionEPER: "",
      choiceThreeTP2: "",
      questionFourTP2: "",
      questionFiveTP2: "",
      questionSixTP2: "",
    },
    mode: "all",
  });
  // TT form
  const formMethodsFive = useForm({
    defaultValues: {
      TTEvidentionIPRHours: "",
      TTEvidentionGPRHours: "",
      TTEvidentionIndividualSupervisions: "",
      TTEvidentionGroupSupervisions: "",
      TTWorkWithClientsHours: "",
      TTSupervisorApproval: false,
      TTZavrsniOR: false,
      TTCaseStudyOne: false,
      selectOneTT: "",
      checkOneTT: false,
      checkTwoTT: false,
      checkThreeTT: false,
    },
    mode: "all",
  });
  const fetchApplicationCallback = useCallback(() => {
    fetchApplication(
      programApplicationId,
      authToken,
      setApplication,
      setVisibleForm,
      formMethodsOne,
      formMethodsTwo,
      formMethodsThree,
      formMethodsFour,
      formMethodsFive
    );
  }, [programApplicationId, authToken, setApplication, setVisibleForm]);

  useEffect(() => {
    if (authToken && !evidentionUserID && programApplicationId)
      fetchApplicationCallback();
  }, [fetchApplicationCallback, authToken, evidentionUserID]);

  useEffect(() => {
    const fetchMentorAndTherapies = async () => {
      const response = await getMyMentor(userData.id, authToken);
      setMyMentors(response);
      setMentorOptions(response.map((mentor) => mentor.name));
    };
    if (authToken && role !== "Referada") fetchMentorAndTherapies();
  }, [authToken, userData.id]);

  const fetchUserApplicationsCallback = useCallback(() => {
    fetchUserApplications(
      setVisibleForm,
      data,
      authToken,
      applicationsCreated,
      formMethodsOne,
      formMethodsTwo,
      formMethodsThree,
      formMethodsFour,
      formMethodsFive,
      setApplicationsCreated,
      setIsAccepted,
      setCommentModal
    );
  }, [setVisibleForm, data, authToken, setApplicationsCreated]);
  useEffect(() => {
    if (!programApplicationId && authToken) {
      fetchUserApplicationsCallback();
    }
  }, [
    fetchUserApplicationsCallback,
    authToken,
    userId,
    programApplicationId,
    evidentionUserID,
  ]);

  const sendApplication = async (data, form, programId) => {
    const matchedMentor =
      myMentors?.find(
        (mentor) =>
          Array.isArray(mentorProgramIdsMapping[mentor.programId]) &&
          mentorProgramIdsMapping[mentor.programId].includes(programId)
      ) || null;
    const requestBody = {
      application: data,
      userId: userData.id,
      programId: programId,
      course: form,
      visibleForReferada: true,
      mentorId: matchedMentor?.id || null,
    };
    if (!matchedMentor) {
      console.warn("No mentor matched for programId:", programId);
    }

    try {
      const res = await createApplication(requestBody, authToken, programId);
      const applicationId = res?.dbResponse?.id;
      if (applicationId && matchedMentor?.id != null) {
        const notificationData = {
          primatelj: matchedMentor.id,
          subject: `Aplikacija za upis ${form}`,
          description: `Polaznik ${userData.firstName} ${userData.lastName} je poslao aplikaciju za upis na program: ${form}. Molimo vas da pregledate <a href="/dokumenti/aplikacije-za-upis/anketa/${applicationId}" target="_blank">aplikaciju</a> i odobrite ili odbijete polaznika.`,
          userId: userData.id,
        };
        try {
          await createNotification(notificationData, authToken);
        } catch (notifError) {
          console.error("Notification failed:", notifError);
        }
      }
      setApplicationsCreated((prev) => ({
        ...prev,
        [form]: true,
      }));
      setIsSuccessModalOpen(true);
    } catch (error) {
      console.error("Error creating application:", error);
    }
  };

  const handleResetForm = async (formMethods) => {
    setIsFirstModalOpen(false);
    const formData = formMethods.getValues();
    const jsonString = JSON.stringify(formData);
    let form;
    let programId;
    setErrorFieds(() =>
      Object.keys(formData).filter(
        (key) =>
          (formData[key] === "" || formData[key] === false) &&
          key !== "questionTP8"
      )
    );
    if (formMethods === formMethodsOne) {
      form = "OR";
      programId = 3;
    } else if (formMethods === formMethodsTwo) {
      form = "eOR";
      programId = 7;
    } else if (formMethods === formMethodsThree) {
      form = "TP1";
      programId = 13;
    } else if (formMethods === formMethodsFour) {
      form = "TP2";
      programId = 14;
    } else {
      form = "TT";
      programId = 11;
    }
    const allowedFalseFields = [
      "TTCaseStudyOne",
      "TTZavrsniOR",
      "questionOr5",
      "question6",
      "questionEightTP1",
      "questionSixTP2",
    ];
    if (form === "TP1" && formData.choiceFourTP1 === "Firma") {
      if (formData.questionSixTP1?.trim()) {
        allowedFalseFields.push("questionSevenTP1");
      } else if (formData.questionSevenTP1?.trim()) {
        allowedFalseFields.push("questionSixTP1");
      }
    } else if (form === "TP1" && formData.choiceFourTP1 === "Privatna osoba") {
      allowedFalseFields.push("questionSevenTP1", "questionSixTP1");
    }

    // TP2 logic
    if (form === "TP2" && formData.choiceThreeTP2 === "Firma") {
      if (formData.questionFourTP2?.trim()) {
        allowedFalseFields.push("questionFiveTP2");
      } else if (formData.questionFiveTP2?.trim()) {
        allowedFalseFields.push("questionFourTP2");
      }
    } else if (form === "TP2" && formData.choiceThreeTP2 === "Privatna osoba") {
      allowedFalseFields.push("questionFourTP2", "questionFiveTP2");
    }

    const err = Object.keys(formData).filter((key) => {
      const value = formData[key];
      if (allowedFalseFields.includes(key)) return false;
      return value === "" || value === false;
    });

    if (err.length === 0) {
      try {
        await sendApplication(jsonString, form, programId);
      } catch (error) {
        console.error("Error sending application:", error);
      }
    } else {
      console.log(err);
      alert("Molimo vas popunite sva polja");
    }
  };

  return (
    <div className={styles.container}>
      {isSuccessModalOpen && (
        <Modal
          image={Success}
          title={"Tvoja aplikacija je uspješno poslana."}
          buttons={[
            {
              label: "U redu",
              action: () => setIsSuccessModalOpen(false),
              className: "modal-btn-success",
            },
          ]}
        />
      )}
      {isFirstModalOpen && (
        <Modal
          image={Question}
          title={"Jeste li sigurni da želite poslati aplikaciju?"}
          description={
            "Kada pošaljete aplikaciju odgovori se ne mogu mijenjati!"
          }
          buttons={[
            {
              label: "Odustani",
              action: () => setIsFirstModalOpen(false),
              className:
                "modal-btn-deletePage modal-btn-discontinue-deletePage",
            },
            {
              label: "Pošalji",
              action: () => {
                handleResetForm(formMethodsThree);
              },
              className: "modal-btn-success",
            },
          ]}
        />
      )}
      {!evidentionUserID && (
        <div
          className={styles.backButton}
          onClick={() =>
            userId === "Referada"
              ? navigate("/dokumenti/aplikacije-za-upis")
              : navigate("/dokumenti")
          }
        >
          <ArrowLeftIcon className={styles.backButtonArrow} />
          <p className={styles.backButtonText}>natrag</p>
        </div>
      )}
      <div className={styles.formContainer}>
        {!evidentionUserID && userId === "Polaznik" && (
          <>
            {" "}
            <p className={styles.formTitle}>
              {userId === "Polaznik" ? " Moje aplikacije" : "Aplikacije"} za
              upis višeg stupnja edukacije za psihoterapeuta ITP-a
            </p>
            <p className={styles.formDescription}>
              Ukoliko želiš iskazati interes za upis višeg stupnja edukacije u
              školi Integralne tjelesne psihoterapije, potrebno je ispuniti
              aplikaciju ispod i zadovoljiti sve propisane uvjete.
            </p>
          </>
        )}
        <div className={styles.form}>
          {visibleForm?.map((form, index) => (
            <Accordion
              evidentionUserID={evidentionUserID}
              key={index}
              isOpen={programApplicationId ? true : false}
              title={`Aplikacija za upis ${form}`}
              children={
                form === "OR" ? (
                  <ORForm
                    userId={userId}
                    formMethodsOne={formMethodsOne}
                    handleResetForm={handleResetForm}
                    errorFields={errorFields}
                    applicationsCreated={applicationsCreated}
                    programApplicationId={programApplicationId}
                    evidentionUserID={evidentionUserID}
                    isAccepted={isAccepted}
                    application={application}
                    commentModal={commentModal}
                    fetchApplicationCallback={fetchApplicationCallback}
                  />
                ) : form === "eOR" ? (
                  <EORForm
                    userId={userId}
                    formMethodsTwo={formMethodsTwo}
                    handleResetForm={handleResetForm}
                    applicationsCreated={applicationsCreated}
                    programApplicationId={programApplicationId}
                    evidentionUserID={evidentionUserID}
                    isAccepted={isAccepted}
                    application={application}
                    commentModal={commentModal}
                    fetchApplicationCallback={fetchApplicationCallback}
                  />
                ) : form === "TP1" ? (
                  <TP1Form
                    userId={userId}
                    formMethodsThree={formMethodsThree}
                    handleResetForm={handleResetForm}
                    programApplicationId={programApplicationId}
                    applicationsCreated={applicationsCreated}
                    evidentionUserID={evidentionUserID}
                    isAccepted={isAccepted}
                    errorFields={errorFields}
                    application={application}
                    commentModal={commentModal}
                    fetchApplicationCallback={fetchApplicationCallback}
                  />
                ) : form === "TP2" ? (
                  <TP2Form
                    userId={userId}
                    formMethodsFour={formMethodsFour}
                    handleResetForm={handleResetForm}
                    programApplicationId={programApplicationId}
                    applicationsCreated={applicationsCreated}
                    evidentionUserID={evidentionUserID}
                    isAccepted={isAccepted}
                    errorFields={errorFields}
                    application={application}
                    commentModal={commentModal}
                    fetchApplicationCallback={fetchApplicationCallback}
                  />
                ) : form === "TT" ? (
                  <TTForm
                    userId={userId}
                    formMethodsFive={formMethodsFive}
                    handleResetForm={handleResetForm}
                    applicationsCreated={applicationsCreated}
                    programApplicationId={programApplicationId}
                    evidentionUserID={evidentionUserID}
                    isAccepted={isAccepted}
                    application={application}
                    errorFields={errorFields}
                    commentModal={commentModal}
                    fetchApplicationCallback={fetchApplicationCallback}
                  />
                ) : (
                  ""
                )
              }
            />
          ))}
          {visibleForm.length === 0 && (
            <div
              style={{
                marginTop: 30,
                boxShadow: "4px 4px 64px 0px #5f6d7e1a",
                border: "1px solid #e2e2e2",
                borderRadius: 8,
              }}
            >
              <p
                className={styles.formDescription}
                style={{ fontSize: 16, textAlign: "center", width: "98%" }}
              >
                Trenutno nemate dostupnih aplikacija
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default EnrollmentForm;
